import { Field, useFormikContext } from 'formik'
import { useEffect, useState } from 'react'

import RadioButton from '../../../RadioButton'
import TextBox from '../../../TextBox'
import { taxesOptions } from '../../../../sharedConstants'

const TaxDetails = ({ id }) => {
  const { values, setFieldValue } = useFormikContext()
  const [taxOptions, setTaxOptions] = useState()

  const setDefaultTaxesValue = () => {
    if (!values.taxable) setTaxOptions(taxesOptions.NON_TAXABLE)
    if (values.taxable) setTaxOptions(taxesOptions.TAXABLE)
    if (values.taxInclusive) setTaxOptions(taxesOptions.TAX_INCLUSIVE)
  }

  const handleNonTaxableClick = () => {
    setTaxOptions(taxesOptions.NON_TAXABLE)
    setFieldValue('taxable', false)
    setFieldValue('taxInclusive', false)
  }

  const handleTaxableClick = () => {
    setTaxOptions(taxesOptions.TAXABLE)
    setFieldValue('taxable', true)
    setFieldValue('taxInclusive', false)
  }

  const handleTaxInclusiveClick = () => {
    setTaxOptions(taxesOptions.TAX_INCLUSIVE)
    setFieldValue('taxable', false)
    setFieldValue('taxInclusive', true)
  }

  useEffect(() => {
    setDefaultTaxesValue()
  }, [])

  return (
    <>
      <h3 id={id} className="header-title">
        Tax
      </h3>
      <div className="content-wrapper -flags-wrapper">
        <span className="content-value">
          <Field
            component={RadioButton}
            name="taxable"
            placeholder="Non-Taxable"
            type="radio"
            checked={taxOptions === 'Non-Taxable'}
            onClick={handleNonTaxableClick}
          />
        </span>
      </div>
      <div className="content-wrapper -flags-wrapper -input-wrapper">
        <span className="content-value">
          <Field
            component={RadioButton}
            name="taxable"
            placeholder="Tax Added On"
            type="radio"
            checked={taxOptions === 'Tax Added On'}
            onClick={handleTaxableClick}
          />
        </span>
        {taxOptions === 'Tax Added On' && (
          <div className="content-wrapper w-100 mt-sm">
            <Field
              name="taxableRate"
              label="Tax Rate"
              component={TextBox}
              percentage
            />
          </div>
        )}
      </div>
      <div className="content-wrapper -flags-wrapper -input-wrapper">
        <span className="content-value">
          <Field
            component={RadioButton}
            name="taxInclusive"
            placeholder="Tax Inclusive"
            type="radio"
            checked={taxOptions === 'Tax Inclusive'}
            onClick={handleTaxInclusiveClick}
          />
        </span>
        {taxOptions === 'Tax Inclusive' && (
          <div className="content-wrapper w-100 mt-sm">
            <Field
              name="taxInclusiveRate"
              label="Tax Rate"
              component={TextBox}
              percentage
            />
          </div>
        )}
      </div>
    </>
  )
}

export default TaxDetails
